import React from "react";
import { useHistory } from "react-router-dom";
import { Menu, MenuItem } from "@mui/material";

import "./Navbar.scss";
import { SignOut } from "../svg/svgImageList";
import useThemeService from "../../services/theme-service/ThemeService";
import { authentication } from "../../services/authentication/Authentication";
import { translationService } from "../../services/translation/TranslationService";

interface HeaderProfileMenuProps {
  isVisible: boolean;
  anchorElement: HTMLElement | null;
  close: () => void;
}

export default function HeaderProfileMenu(props: HeaderProfileMenuProps) {
  const history = useHistory();
  const { themeClass } = useThemeService();

  const { isVisible, anchorElement, close } = props;

  const goToMyAccount = () => {
    history.push("/my-account");
    close();
  };

  return (
    <Menu
      id="basic-menu"
      anchorEl={anchorElement}
      className="navbar-header-profile-menu"
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isVisible}
      onClose={close}
    >
      <MenuItem id="navbar-my-account" className="navbar-my-account" onClick={goToMyAccount}>
        {translationService.translate("general.my-account")}
      </MenuItem>
      <MenuItem id="navbar-sign-out" className="navbar-sign-out" onClick={authentication.logout}>
        {translationService.translate("general.sign-out")}
        <SignOut className={themeClass(["sign-out-icon"])} />
      </MenuItem>
    </Menu>
  );
}
